import { useCallback, useRef } from 'react'

const MOVE_CANCEL_PX = 14

/** 触控/手写笔长按；鼠标不做计时长按（PC 依赖右键菜单保存）。 */
export function useTouchLongPress(onLongPress: () => void, options?: { ms?: number; disabled?: boolean }) {
  const ms = options?.ms ?? 560
  const disabled = !!options?.disabled
  const timerRef = useRef<number | undefined>(undefined)
  const originRef = useRef({ x: 0, y: 0 })

  const clear = useCallback(() => {
    if (timerRef.current != null) {
      window.clearTimeout(timerRef.current)
      timerRef.current = undefined
    }
  }, [])

  const onPointerDown = useCallback(
    (e: React.PointerEvent) => {
      if (disabled) return
      if (e.pointerType === 'mouse') return
      if (e.button !== 0) return
      clear()
      originRef.current = { x: e.clientX, y: e.clientY }
      timerRef.current = window.setTimeout(() => {
        timerRef.current = undefined
        onLongPress()
      }, ms)
    },
    [clear, disabled, ms, onLongPress],
  )

  const onPointerMove = useCallback(
    (e: React.PointerEvent) => {
      if (timerRef.current == null) return
      const dx = e.clientX - originRef.current.x
      const dy = e.clientY - originRef.current.y
      if (dx * dx + dy * dy > MOVE_CANCEL_PX * MOVE_CANCEL_PX) {
        clear()
      }
    },
    [clear],
  )

  const onPointerUp = useCallback((_e: React.PointerEvent) => {
    clear()
  }, [clear])

  const onPointerCancel = useCallback((_e: React.PointerEvent) => {
    clear()
  }, [clear])

  return {
    onPointerDown,
    onPointerMove,
    onPointerUp,
    onPointerCancel,
  }
}
